import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import * as _ from 'lodash';
import {ChartType} from '../../../utils/highchart/chart-type';
import {ReportSelectionService} from '../../services/reportSelection.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'graph-menu-panel',
  templateUrl: './graph-menu-panel.component.html',
  styleUrls: ['./graph-menu-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GraphMenuPanelComponent implements OnInit {

  @Input() selectedReport;
  @Output() selectChanged = new EventEmitter<any>();

  menu: any;

  constructor(private reportSelectionService: ReportSelectionService,
              private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.menu = JSON.parse(sessionStorage.getItem('ReportRepository'));

    if (this.route.snapshot.params && this.route.snapshot.params.statistic) {
      const reports = [];

      this.menu.map(item => {
        reports.push(...item.reports);
      });

      const filteredReport = reports.find(report => report.reportIdentifier === this.route.snapshot.params.statistic);
      this.onSelect(filteredReport);
    }
  }

  onSelect(report): void {
    if (!this.isSelectedReport(report)) {
      this.selectChanged.emit(report);
      this.reportSelectionService.setReportSelection(report);
    }
  }

  getChartIcon(report): string {
    const type = report.graphViews.defaultGraphView;
    return ChartType[type].icon;
  }

  isSelectedReport(report): boolean {
    return _.isEqual(report.reportIdentifier, this.selectedReport.reportIdentifier);
  }

  isSelectedElement(element): boolean {
    return _.isEqual(element.elementType, this.selectedReport.reportType);
  }
}
